import React from 'react'

import { ChyronOverlay } from '../../../Stage/chyron-overlay'
import Floor from '../../../Stage/floor/floor'
import ScaledStage from '../../../Stage/scaled-stage'

import './stage-container.scss'

const StageContainer = () => {
  return (
    <div className="scaled-stage-container">
      <ScaledStage>
        <Floor />
        <ChyronOverlay />
      </ScaledStage>
    </div>
  )
}

export default StageContainer
